export const FRONTAPP_ARTICLES = {
	ciec: 'https://www.heru.app/ayuda/vincular-rfc/',
	efirma: 'https://www.heru.app/ayuda/vincular-efirma/',
};
